import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IRateDetail } from '@ruby/modules/rate-inquiry/models/rate-inquiry.interface';
import * as RateCoreActions from '@ruby/modules/rate-inquiry/store/actions/rate-core.actions';
import * as fromRateCore from '@ruby/modules/rate-inquiry/store/reducers/rate-core.reducer';
import * as RateCoreSelectors from '@ruby/modules/rate-inquiry/store/selectors/rate-core.selectors';

@Component({
  selector: 'ng-rate-results-container',
  templateUrl: './rate-results.container.html',
  styleUrls: ['./rate-results.container.scss']
})
export class RateResultsContainerComponent {
  store$: Observable<{ result: Array<IRateDetail>; displayResults: boolean; loading: boolean }>;

  constructor(private store: Store<fromRateCore.State>) {
    this.store$ = this.store.select(RateCoreSelectors.selectResultFromCoreState);
  }

  /**
   * Clear All Rate Data
   *
   * @summary Dispatch clearAllRateData action
   * @returns void
   */
  clearAllRateData(): void {
    this.store.dispatch(RateCoreActions.clearAllRateData());
  }
}
